import React from 'react';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import { withStyles } from '@material-ui/core/styles';

const StyledRadio = withStyles((theme) => ({
  root: {
    color: `${theme.palette.text.primary} !important`,
  },
}))(Radio);

const DSRadio: React.FC<RadioProps> = (props) => <StyledRadio {...props} />;

export default DSRadio;
